// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont {
  display: flex;
  flex-direction: row; /* Default to row for large screens */
  justify-content: center; /* Horizontally center the sentences */
}

/* Media Query for Small Screens */
@media (max-width: 600px) {
  .cont {
    align-items: center; /* Vertically center the sentences */
    flex-direction: column; /* Stack sentences vertically on small screens */
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/modules/home/home.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA,EAAA,qCAAA;EACA,uBAAA,EAAA,sCAAA;AAAF;;AAGA,kCAAA;AACA;EACE;IACE,mBAAA,EAAA,oCAAA;IACA,sBAAA,EAAA,gDAAA;EAAF;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
